export default {
  generatingReport: state => state.generatingReport,
  multipleReportsDownloading: state => state.multipleReportsDownloading,
  multipleReportsIsDownloading: state => state.multipleReportsIsDownloading,
  reportingStatus: state => state.reportingStatus,
  reportingUserMessage: state => state.reportingUserMessage,
  reportIsDownloading: state => (reportId) => state.reportsDownloading[reportId],
  reportNavCategories: state => state.reportNavCategories,
  reportProcessed: state => state.reportProcessed,
  reportTypes: state => state.reportTypes,
  reportsDownloading: state => state.reportsDownloading,
  reportsHaveLoaded: state =>state.reportsHaveLoaded,
  reportsLoading: state => state.reportsLoading,
  reportsToShow: state => {
    if (state.selectedReportType.toLowerCase() == 'all') {
      return state.reports;
    } else {
      return state.reports.filter(report => report.status == state.selectedReportType);
    }
  },
  selectedReportType: state => state.selectedReportType,
}